import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex items-start px-2 py-2 pt-3 text-xs group w-76 max-h-15" };
const _hoisted_2 = { class: "flex-1" };
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = {
    key: 0,
    class: "py-1 pr-1"
};
const _hoisted_5 = { class: "flex justify-end h-5 px-2 text-base font-bold text-primary-900 dark:text-gray-300" };
const _hoisted_6 = { class: "flex justify-start text-gray-400" };
const _hoisted_7 = { class: "flex justify-end text-gray-400" };
const _hoisted_8 = { class: "flex" };
import transitions from '@/helpers/transitions';
import GroupNameInput from '@/components/groups/GroupNameInput.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GroupHeader',
    props: {
        name: { type: String, default: '' },
        allowRename: { type: Boolean, default: false },
        number: { type: Number, default: null },
        showNumber: { type: Boolean, default: true }
    },
    emits: ['rename', 'focus'],
    setup(__props, { emit }) {
        const { randomDelayedScaleIn } = transitions.scale;
        function handleRename(newName) {
            emit('rename', newName);
        }
        function handleFocus() {
            emit('focus');
        }
        return (_ctx, _cache) => {
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(GroupNameInput, {
                            disabled: !__props.allowRename,
                            value: __props.name,
                            onInput: handleRename,
                            onFocus: handleFocus
                        }, null, 8, ["disabled", "value"]),
                        (__props.number && __props.showNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.number), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "user-renaming")
                    ]),
                    _createElementVNode("p", _hoisted_7, [
                        _renderSlot(_ctx.$slots, "info")
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_transition_a11y, {
                        css: false,
                        onEnter: _unref(randomDelayedScaleIn)
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "buttons")
                        ], undefined, true),
                        _: 3
                    }, 8, ["onEnter"])
                ])
            ]));
        };
    }
});
